
































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import WorkGroup from '../../../store/entities/sm/workgroups'
import CreateGroupMember from './create-workgroup-member.vue'
import searchworkgroup from '@/store/entities/sm/searchworkgroup'
@Component({
  components: { CreateGroupMember }
})
export default class CreateWorkLog extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean
  WorkGroupData: WorkGroup = new WorkGroup()
  createmember: boolean = false
  searchworkgroup: searchworkgroup = new searchworkgroup()
  logmembers: Array<any> = []
  usermemberdata: Array<any> = []
  get roles() {
    return this.$store.state.user.roles
  }
  save() {
    this.logmembers = []
    //this.$emit('save-success')
    this.$emit('input', false)
  }
  //删除标签
  removeMember(index) {
    this.logmembers.splice(index, 1)
  }
  async addmember() {
    this.usermemberdata = []
    this.$store.commit('worklog/setmemberliststring', this.logmembers)
    this.createmember = true
  }
  async handleClose() {
    this.logmembers = this.$store.state.worklog.memberlist
  }
  created() {}
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit('input', value)
    } else {
      this.WorkGroupData = this.$store.state.workgroup.editworkgroup
      let userId = this.WorkGroupData.groupMember.split(',').map(String)
      let username = this.WorkGroupData.groupMemberName.split(',').map(String)
      for (let i = 0; i < userId.length; i++) {
        if (userId[i] != '') {
          this.logmembers.push({ id: userId[i], label: username[i] })
        }
      }
    }
  }
}
